import { Component } from 'react';
import { inject, observer } from 'mobx-react';

//components
import withLocalization from '~/hoc/withLocalization';
import TableWidget from '../TableWidget.js';
import WagetypeRefetch from '../WagetypeRefetch.js';

//utils
import { distanceUnitType } from '../../../../utils/dateFormat'

class KilometerRules extends Component {
    constructor(props) {
        super(props);
        this.state = {
            kilometersRules: [],
            wageType: props.commonStore.getWageTypesAccordingToIntegrations(props.commonStore?.config?.integration_details, 'su') || [],
            lastUpdated: props.commonStore.getWageTypesAccordingToIntegrations(props.commonStore?.config?.integration_details, 'last_updated') || null,
            isLoadingWageTypes: false
        }
        this.loadData = this.loadData.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { currentEntity } = this.props.clientStore;
        if (currentEntity.client.data && currentEntity.client.data.extendedRules) {
            const extendedRules = Object.assign({}, currentEntity.client.data.extendedRules);
            this.setState({
                kilometersRules: extendedRules.kilometersRules
            })
        }
    }

    refetchWageType = async () => {
        const { commonStore, t } = this.props;
        try {
            await commonStore.refetchWagetypes();
            commonStore.addNotification(t('Successfully refetched wagetypes'), null, 'success');
            const _wagetype = commonStore.getWageTypesAccordingToIntegrations(commonStore?.config?.integration_details, 'su') || [];
            const _lastUpdated = commonStore.getWageTypesAccordingToIntegrations(commonStore?.config?.integration_details, 'last_updated') || null;
            this.setState({ wageType: _wagetype, lastUpdated: _lastUpdated, isLoadingWageTypes: false });

        } catch (err) {
            console.error(err);
            commonStore.addNotification(t('Something went wrong'), null, 'error');
            this.setState({ isLoadingWageTypes: false });
        }
    }

    render() {
        const { kilometersRules, wageType, lastUpdated, isLoadingWageType } = this.state;
        const dateTimeRules = this.props.commonStore.getDateTimeRules();

        let headers = ['Distance / Zone', 'Max' + " " + `${distanceUnitType(dateTimeRules)}`];
        let metaData = [{ field: 'distance', type: 'text', placeholder: 'Distance / Zone', required: true, unique: true },
        { field: 'max_km', type: 'text', placeholder: '0', required: false, unique: true }]

        if (wageType?.length) {
            headers = ['Distance / Zone', 'Wage Type', `Max ${distanceUnitType(dateTimeRules)}`];
            metaData = [{ field: 'distance', type: 'text', placeholder: 'Distance / Zone', required: true, unique: true },
            { field: 'payrollWageType', type: 'select', placeholder: 'Wage Type', select: true, data: wageType, unique: true },
            { field: 'max_km', type: 'text', placeholder: '0', required: false, unique: true }];
        }

        return (
            <div>
                {!!wageType.length &&
                    <WagetypeRefetch
                        t={this.props.t}
                        refetch={() => this.setState({ isLoadingWageTypes: true }, this.refetchWageType)}
                        lastUpdated={lastUpdated}
                        isLoading={isLoadingWageType}
                        dateTimeRules={dateTimeRules}
                        extraNote={this.props.commonStore.config?.client?.gps_data ? this.props.t('Please select the payroll wagetype if you want to Sync the Km/Miles to integration system') : null}
                    />
                }
                <TableWidget
                    headers={headers}
                    metaData={metaData}
                    data={kilometersRules}
                    onChange={data => this.props.handleUserDataChange('kilometersRules', data)}
                    className={'mb-100'}
                />
            </div >
        );
    }
}
export default inject('clientStore', 'commonStore')(withLocalization(observer(KilometerRules)));
